export default __webpack_public_path__ + "static/media/Station-Marker-Jabalpur.d1df20c2.jpg";